import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";

import ProjectManagement from "../../assets/icons2/settings.png";
import QualityAnalysis from "../../assets/icons2/test.png";
import DigitalMarketing from "../../assets/icons2/ads.png";
import SocialMediaManagement from "../../assets/icons2/heart.png";

import WomenWillLogo from "../../assets/logos/WomenWill.png";
import UKNigTechHubLogo from "../../assets/logos/UKNigTechHub.png";
import GwGLogo from "../../assets/logos/GwG.png";
import GDSCLogo from "../../assets/logos/GDSC.png";

import { Link } from "react-scroll";

const Home = () => {
  return (
    <div>
      <Navbar />
      <section className="masthead" id="home">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-6">
              <h1 className="animate__animated animate__fadeInDown">
                Redefining <span>processes</span>, <span>systems</span> and{" "}
                <span>digital engagements</span> for brands and small
                businesses.
              </h1>
              <button className="btn btn-primary animate__animated animate__fadeInDown">
                <Link
                  activeClass="active"
                  className="test1"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={200}
                >
                  Get in touch
                </Link>
              </button>
            </div>
            <div className="col-md-6"></div>
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-7  animate__animated animate__fadeIn">
              <span>WHO WE ARE</span>
              <h3>About Us</h3>
              <p>
                Digirep is a digital agency that works with organizations of
                diverse and strategic projects. We are focused on collaborating
                with organizations and small businesses in developing programs,
                procedures, and strategies while executing on priorities.
              </p>
              <p>
                Our management team has over 15 years of combined digital
                marketing experience and has worked with some of the world's
                most prominent brands.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-7  animate__animated animate__fadeIn">
              <span>WHAT WE DO</span>
              <h3>Our Services</h3>
              <p>
                Our project management experience and knowledge enable us to
                deliver a fully integrated end-to-end process.
              </p>
            </div>
          </div>
          <div className="row gx-5 row-flex justify-content-center">
            <div className="col-md-6 col-lg-3">
              <div className="about-item animate__animated animate__fadeIn">
                <img
                  className="img-fluid"
                  src={ProjectManagement}
                  alt="icon1"
                />
                <h5>Project Management</h5>
                <p>
                  Better processes, tools and procedures for broadly diversified
                  projects.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="about-item animate__animated animate__fadeIn">
                <img className="img-fluid" src={DigitalMarketing} alt="icon3" />
                <h5>Digital & Brand Marketing</h5>
                <p>
                  Targeted marketing campaigns designed for brand awareness and
                  growth.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="about-item animate__animated animate__fadeIn">
                <img className="img-fluid" src={QualityAnalysis} alt="icon4" />
                <h5>Quality Analysis & Assessment</h5>
                <p>
                  Reliable and actionable information to help your
                  organization's overall presence and service delivery.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="about-item animate__animated animate__fadeIn">
                <img
                  className="img-fluid"
                  src={SocialMediaManagement}
                  alt="icon5"
                />
                <h5>Content & Social Media Management</h5>
                <p>
                  Integrated communications and focused set of activities to
                  promote your products or services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="projects" className="projects">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-7 animate__animated animate__fadeIn">
              <span>WHAT WE'VE DONE</span>
              <h3>Our Projects</h3>
              <p>
                We take pride in providing world-class services in areas such as
                digital marketing, business analysis, contract administration,
                and performance reporting, to name a few.
              </p>
            </div>
          </div>

          <div className="row gx-5 row-flex">
            <div className="col-md-6">
              <div className="project-item project-item-img">
                <img className="img-fluid" src={GwGLogo} alt="icon1" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="project-item project-item-text text-left animate__animated animate__fadeIn">
                <h5>Grow With Google</h5>
                <p>
                  The Google Digital Skills project is by far one of the most
                  layered projects we have worked on.
                </p>{" "}
                <p>
                  {" "}
                  The challenge was to train 1-Million people across Africa with
                  satellite teams in 3 countries in Africa and {" "}
                  <a href="https://google.com">Google</a> needed a team that
                  could help them execute this. In the following areas, we have
                  supported the program.
                </p>
                <p>
                  <span>Building Team:</span> We helped ramp up for the Nigeria
                  based management team to increase localised visibility.
                </p>
                <p>
                  <span>Tailored solutions:</span> We built a monitoring tool
                  that reflects the real time position of the project.
                </p>
                <p>
                  <span>Quality Assurance:</span> We embedded a system that
                  gives the program owners confidence of the level of quality
                  being upheld
                </p>
                <p>
                  <span>Social Media and Platform Expertise:</span> We developed
                  campaigns and monthly content calendars for all social media
                  channels, as well as newsletters for stakeholders. We were
                  also completely responsible for building social media
                  followers, which grew organically from 0 to over 100k
                  followers on Facebook, Instagram, and Twitter.
                </p>
              </div>
            </div>
          </div>

          <div className="row gx-5 row-flex flex-row-reverse">
            <div className="col-md-6">
              <div className="project-item project-item-img">
                <img className="img-fluid" src={UKNigTechHubLogo} alt="icon1" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="project-item project-item-text text-left animate__animated animate__fadeIn">
                <h5>UK-NG Tech Hub</h5>
                <p>
                  Digirep supported the pilot programmes for the UK-NG Tech Hub
                  - an initiative by the UK Government's Digital, Culture, Media
                  and Sports to support the growth of technology ecosystem in
                  Nigeria. We contributed to the program in the following
                  categories:
                </p>

                <p>
                  <span>Project Management and Communications:</span> We
                  collaborated with the UK-NG team to develop programme plans
                  and logistics for the tech hub. We also provided project
                  management support and managed communications with
                  stakeholders.
                </p>

                <p>
                  <span>Event management and logistics:</span> We were in charge
                  of successful delivery of the tech hub's weekly and monthly
                  events.
                </p>
              </div>
            </div>
          </div>

          <div className="row gx-5 row-flex">
            <div className="col-md-6">
              <div className="project-item project-item-img">
                <img className="img-fluid" src={GDSCLogo} alt="icon1" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="project-item project-item-text text-left animate__animated animate__fadeIn">
                <h5>Google Developers Student Club </h5>
                <p>
                  This program is a network of university students who are
                  interested in <a href="https://google.com">Google</a>{" "}
                  developer tools.
                </p>

                <p>
                  Through a fund request system we developed, we manage the
                  disbursement of funds in various currencies.
                </p>

                <p>
                  We assisted with the establishment of many clubs and oversaw
                  the program's application and selection process.
                </p>
              </div>
            </div>
          </div>

          <div className="row gx-5 row-flex flex-row-reverse">
            <div className="col-md-6">
              <div className="project-item project-item-img">
                <img className="img-fluid" src={WomenWillLogo} alt="icon1" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="project-item project-item-text text-left animate__animated animate__fadeIn">
                <h5>WomenWill Africa</h5>
                <p>
                  This is a Grow With Google initiative that inspires women to
                  grow and develop with the support of{" "}
                  <a href="https://grow.google/">Grow With Google</a>.
                </p>

                <p>
                  We provided support
                  for digital skills training for womenacross Africa, raised awareness for events, and developed content and social assets for all social media platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
